module.exports = __webpack_public_path__ + "minus4.svg?1f9e87bfcf8e654e1341606629183c0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minus4.svg
// module id = 118
// module chunks = 0